import React from 'react';
import { DollarSignIcon, UsersIcon, BookOpenIcon, GlobeIcon, SparklesIcon, TrophyIcon, ArrowRightIcon } from 'lucide-react';
import { trackLead } from './MetaPixel';
export function BenefitsSection() {
  const benefits = [{
    icon: DollarSignIcon,
    title: 'Comisiones Atractivas',
    description: 'Sistema de compensación diseñado para recompensar tu esfuerzo y dedicación'
  }, {
    icon: UsersIcon,
    title: 'Equipo que Cierra por Ti',
    description: 'Sistema probado con soporte continuo del equipo élite'
  }, {
    icon: BookOpenIcon,
    title: 'Formación Paso a Paso',
    description: 'Certificación completa desde cero hasta experto'
  }, {
    icon: GlobeIcon,
    title: 'Comunidad Internacional',
    description: 'Acceso a una red global de closers exitosos'
  }, {
    icon: SparklesIcon,
    title: 'Libertad y Propósito Real',
    description: 'Trabaja desde cualquier lugar, en tus propios términos'
  }, {
    icon: TrophyIcon,
    title: 'Certificación Reconocida',
    description: 'Acreditación oficial que valida tu expertise profesional'
  }];
  const handleCTA = () => {
    trackLead();
    const baseUrl = 'https://closerdigital.net/F/NLeon2';
    const utmParams = '?utm_source=facebook&utm_medium=cpc&utm_campaign={{campaign.name}}&utm_adset={{adset.name}}&utm_ad={{ad.name}}&utm_content={{ad.id}}&ref=alexa';
    window.location.href = baseUrl + utmParams;
  };
  return <section className="w-full bg-[#1C1C1C] py-12 md:py-24 px-4 md:px-6" data-id="element-46">
      <div className="max-w-7xl mx-auto" data-id="element-47">
        <div className="text-center mb-8 md:mb-16" data-id="element-48">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-4" data-id="element-49">
            Beneficios <span className="text-[#D4AF37]" data-id="element-50">Transformadores</span>
          </h2>
          <div className="w-24 md:w-32 h-1 bg-gradient-to-r from-[#FF4F75] to-[#D4AF37] mx-auto my-4 md:my-8" data-id="element-51"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-52">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="group bg-gradient-to-br from-[#0D0D0D] to-[#1C1C1C] p-5 md:p-8 rounded-2xl border border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,175,55,0.2)]" data-id="element-53">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#D4AF37] to-[#FF4F75] rounded-full flex items-center justify-center mb-3 md:mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-54">
                  <Icon className="w-6 h-6 md:w-8 md:h-8 text-white" data-id="element-55" />
                </div>
                <h3 className="font-['Playfair_Display'] text-lg md:text-2xl font-bold text-white mb-2 md:mb-4" data-id="element-56">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-57">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
        <div className="text-center mt-8 md:mt-16" data-id="element-58">
          <button onClick={handleCTA} className="group inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 bg-gradient-to-r from-[#D4AF37] to-[#FF4F75] rounded-full font-['Montserrat'] font-semibold text-sm md:text-base text-white transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)]" data-id="element-59">
            <span data-id="element-60">Descubre el Sistema Completo</span>
            <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" data-id="element-61" />
          </button>
        </div>
      </div>
    </section>;
}